import { KeycloakProfile } from '../../../redux/reducers/auth'
import { APEX } from '../../../constants/businessTerritory'
import { CurrentUser } from '../types'

/** Role oprávněné k backoffice akcím (zrcadlí BE itrader.funds.backoffice-roles, O1). */
const BACKOFFICE_ROLES = ['CEO', 'PORTF MANAGER', 'ASSISTANT']
const CEO_ROLES = ['CEO', 'CEO IF']

/** Adaptér Keycloak/redux uživatele na CurrentUser modulu (gating). BE gating je stejně vynucen. */
export function toCurrentUser(user: KeycloakProfile): CurrentUser {
  const roles = user.roles || []
  const isCeo = roles.some((r) => CEO_ROLES.indexOf(r) >= 0)
  const isBackoffice = isCeo || roles.some((r) => BACKOFFICE_ROLES.indexOf(r) >= 0)
  return {
    territory: user.businessTerritoryId === APEX ? 'APEX' : 'IMPERIUM',
    isCeo,
    isBackoffice,
    userName: user.username || '',
  }
}
